import { render, staticRenderFns } from "./BlockType112.vue?vue&type=template&id=0e80d045"
import script from "./BlockType112.vue?vue&type=script&lang=ts"
export * from "./BlockType112.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports